var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plan-card"},[_c('div',{ref:"wordChart",staticClass:"plan-box",attrs:{"id":"chart-panel"}})])}
var staticRenderFns = []

export { render, staticRenderFns }